// removed by extract-text-webpack-plugin
module.exports = {"editablesForm":"styles__editablesForm___2VJmi","editablesTitle":"styles__editablesTitle___1wqcz","editablesButton":"styles__editablesButton___2b3Lq"};